import { __assign } from "tslib";
/**
 * @fileoverview path çä¸äºå·¥å·
 * @author dxq613@gmail.com
 */
import { PathUtil } from '@antv/g-base';
import { Quad as QuadUtil } from '@antv/g-math';
import { Cubic as CubicUtil } from '@antv/g-math';
import { ext } from '@antv/matrix-util';
import * as vec3 from 'gl-matrix/vec3';
import { inBox } from './util';
import inLine from './in-stroke/line';
import inArc from './in-stroke/arc';
var transform = ext.transform;
function hasArc(path) {
    var hasArc = false;
    var count = path.length;
    for (var i = 0; i < count; i++) {
        var params = path[i];
        var cmd = params[0];
        if (cmd === 'C' || cmd === 'A' || cmd === 'Q') {
            hasArc = true;
            break;
        }
    }
    return hasArc;
}
function isPointInStroke(segments, lineWidth, x, y, length) {
    var isHit = false;
    var halfWidth = lineWidth / 2;
    for (var i = 0; i < segments.length; i++) {
        var segment = segments[i];
        var currentPoint = segment.currentPoint, params = segment.params, prePoint = segment.prePoint, box = segment.box;
        // å¦æå¨åé¢å·²ç»çæè¿åå´çï¼ç´æ¥æç§åå´çè®¡ç®
        if (box && !inBox(box.x - halfWidth, box.y - halfWidth, box.width + lineWidth, box.height + lineWidth, x, y)) {
            continue;
        }
        switch (segment.command) {
            // L å Z é½æ¯ç´çº¿ï¼ M ä¸è¿è¡æ¾å
            case 'L':
            case 'Z':
                isHit = inLine(prePoint[0], prePoint[1], currentPoint[0], currentPoint[1], lineWidth, x, y);
                break;
            case 'Q':
                var qDistance = QuadUtil.pointDistance(prePoint[0], prePoint[1], params[1], params[2], params[3], params[4], x, y);
                isHit = qDistance <= lineWidth / 2;
                break;
            case 'C':
                var cDistance = CubicUtil.pointDistance(prePoint[0], // ä¸ä¸æ®µç»æä½ç½®, å³ C çèµ·å§ç¹
                prePoint[1], params[1], // 'C' çåæ°ï¼1ã2 ä¸ºç¬¬ä¸ä¸ªæ§å¶ç¹ï¼3ã4 ä¸ºç¬¬äºä¸ªæ§å¶ç¹ï¼5ã6 ä¸ºç»æç¹
                params[2], params[3], params[4], params[5], params[6], x, y, length);
                isHit = cDistance <= lineWidth / 2;
                break;
            case 'A':
                // è®¡ç®ç¹å°æ¤­ååå¼§çè·ç¦»ï¼ææ¶ä½¿ç¨è¿ä¼¼ç®æ³ï¼åé¢å¯ä»¥æ¹æåå²æ³æ±æè¿è·ç¦»
                var arcParams = segment.arcParams;
                var cx = arcParams.cx, cy = arcParams.cy, rx = arcParams.rx, ry = arcParams.ry, startAngle = arcParams.startAngle, endAngle = arcParams.endAngle, xRotation = arcParams.xRotation;
                var p = [x, y, 1];
                var r = rx > ry ? rx : ry;
                var scaleX = rx > ry ? 1 : rx / ry;
                var scaleY = rx > ry ? ry / rx : 1;
                var m = transform(null, [
                    ['t', -cx, -cy],
                    ['r', -xRotation],
                    ['s', 1 / scaleX, 1 / scaleY],
                ]);
                vec3.transformMat3(p, p, m);
                isHit = inArc(0, 0, r, startAngle, endAngle, lineWidth, p[0], p[1]);
                break;
            default:
                break;
        }
        if (isHit) {
            break;
        }
    }
    return isHit;
}
/**
 * æååºåé¨çé­åå¤è¾¹å½¢åéé­åçå¤è¾¹å½¢ï¼åè®¾ path ä¸å­å¨åå¼§
 * @param {Array} path è·¯å¾
 * @returns {Array} ç¹çéå
 */
function extractPolygons(path) {
    var count = path.length;
    var polygons = [];
    var polylines = [];
    var points = []; // é²æ­¢ç¬¬ä¸ä¸ªå½ä»¤ä¸æ¯ 'M'
    for (var i = 0; i < count; i++) {
        var params = path[i];
        var cmd = params[0];
        if (cmd === 'M') {
            // éå° 'M' å¤å®æ¯å¦æ¯æ°æ°ç»ï¼æ°æ°ç»ä¸­æ²¡æç¹
            if (points.length) {
                // å¦æå­å¨ç¹ï¼åè¯´ææ²¡æéå° 'Z'ï¼å¼å§äºä¸ä¸ªæ°çå¤è¾¹å½¢
                polylines.push(points);
                points = []; // åå»ºæ°çç¹
            }
            points.push([params[1], params[2]]);
        }
        else if (cmd === 'Z') {
            if (points.length) {
                // å­å¨ç¹
                polygons.push(points);
                points = []; // å¼å§æ°çç¹éå
            }
            // å¦æä¸å­å¨ç¹ï¼åæ¶ 'Z'ï¼åè¯´ææ¯éè¯¯ï¼ä¸å¤ç
        }
        else {
            points.push([params[1], params[2]]);
        }
    }
    // è¯´æ points æªæ¾å¥ polygons æè polyline
    // ä»å½åªæä¸ä¸ª Mï¼æ²¡æ Z æ¶ä¼åçè¿ç§æåµ
    if (points.length > 0) {
        polylines.push(points);
    }
    return {
        polygons: polygons,
        polylines: polylines,
    };
}
export default __assign({ hasArc: hasArc, extractPolygons: extractPolygons, isPointInStroke: isPointInStroke }, PathUtil);
//# sourceMappingURL=path.js.map